import React, { useState } from 'react'
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { loadingChange, login, modalChange } from '../../redux/slices/AuthSlice';
import { URL } from '../../config';
import { setErrorMessage } from '../../redux/slices/MessageSlice';

const Login = () => {
  const navigate = useNavigate()
    const dispatch=useDispatch();
    const [cookies, setCookie] = useCookies(['user']);
    const [email,setEmail]=useState('');
    const [password,setPassword]=useState('');
 const loginHandel =(e)=>{
 e.preventDefault();
 dispatch(loadingChange());
 axios.post(`${URL}/api/auth/login`, {
      email: email,
      password:password
    })
    .then(function (response) {
     
      if(response.data.success){
        console.log(response.data.data.token);
        const user=response.data.data.user;
        const token=response.data.data.token;
        setCookie('user', user, { path: '/' });
        setCookie('token', token, { path: '/' });
        dispatch(login({user:user,token:token}))
        dispatch(modalChange());
      }
      else{
        console.log(response.data); 
        dispatch(setErrorMessage('خطأ فى البيانات'));
      }
      dispatch(loadingChange());
        })
    .catch(function (error) {
      console.log('error',error);
      dispatch(setErrorMessage(error.response.data.message))
      dispatch(loadingChange());
    });
 }

  return (
     
        <div className='login-body' >
          
        <i className="fa-regular fa-user"></i>
        <h3>تسجيل الدخول</h3>
        <form onSubmit={  loginHandel} >
        <label for="email">البريد الإلكترونى</label>
        <input type='text' id="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='your@email.com'/>
        <label for="password">الرقم السرى</label>
        <input type='password' id="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='password'/>
        <input type='submit' style={{ marginTop:"30px" }}   value="دخول"/>
        </form>
        </div>
  )
}

export default Login
